import common from "@/langs/ja/common";
import model from "@/langs/ja/model";
import message from "@/langs/ja/message";
import validation from "@/langs/ja/validation";
import modal from "@/langs/ja/modal";
import toast from "@/langs/ja/toast";

export default {
    'appName': 'Vue Typescript Base',
    'common': common,
    'model': model,
    'message': message,
    'modal': modal,
    'toast': toast,
    'validation': validation
}
